import React, {
  useEffect,
  useState,
  useContext
} from 'react';
import {
  Box,
  Container,
  Button,
  makeStyles,
  Typography
} from '@material-ui/core';
import { Navigate } from 'react-router-dom';
import Page from 'src/components/Page';
import Tabelas from '../../shared/component/UIElements/Tabelas';
import { useHttpClient } from '../../hooks/http-hook';
import { AuthContext } from '../../shared/context/auth-context';
import ErrorMessage from '../../shared/component/UIElements/ErrorMessage';
import LoadingSpinner from '../../shared/component/UIElements/LoadingSpinner';
import Modal from '../../shared/component/Modal';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  button: {
    color: 'white',
    paddingRight: '40px',
    paddingLeft: '40px',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px'
  },
  nome: {
    marginBottom: '15px',
  }
}));

const Emprestimos = () => {
  const auth = useContext(AuthContext);
  const {
    isLoading,
    error,
    sendRequest,
    clearError
  } = useHttpClient();
  const classes = useStyles();
  const [emprestimos, setEmprestimos] = useState([]);
  const [situacoes, setSituacoes] = useState([]);
  const [query, setQuery] = useState(null);
  const [change, setChange] = useState(null);
  const [navegar, setNavegar] = useState(false);
  const [remover, setRemover] = useState(false);

  const handleEdit = (qual) => {
    setNavegar(`emprestimos/${qual}`);
  };
  const fecharDeletar = () => {
    setRemover(false);
  };
  const abrirDeletar = (qual) => {
    setRemover(qual);
  };
  const handleDelete = async () => {
    try {
      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/emprestimos/${remover}`,
        'DELETE',
        null,
        {
          'Content-Type': 'application/json',
          'x-access-token': auth.token
        }
      );
      console.log(responseData);
      if (responseData.sucesso) {
        setEmprestimos((prevState) => {
          const data = [...prevState.filter((item) => item.id !== remover)];
          setRemover(false);
          return data;
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleBusca = (event) => {
    const searchLower = String(event.target.value).toLowerCase();
    if (String(searchLower).trim().length > 0) {
      const filtradas = emprestimos.filter((acerv) => String(acerv.nome.conteudo).toLowerCase().includes(searchLower));
      console.log(filtradas);
      setQuery(filtradas);
    } else {
      setQuery(null);
    }
  };
  useEffect(() => {
    const fetchEmprestimos = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/emprestimos/`,
          'GET',
          null,
          {
            'Content-Type': 'application/json',
            'x-access-token': auth.token
          }
        );
        console.log(responseData);
        setEmprestimos(() => {
          const data = [...responseData.data.map((emprestimo) => ({
            id: emprestimo._id,
            criacao: {
              conteudo: new Date(emprestimo.createdDate).toLocaleString(),
              tipo: 'data'
            },
            nome: {
              conteudo: (
                <>
                  <Typography>{emprestimo.nome}</Typography>
                  <Typography>{new Date(emprestimo.nascimento).toLocaleDateString()}</Typography>
                </>
              ),
              tipo: 'texto'
            },
            documento: {
              conteudo: emprestimo.documento,
              tipo: 'texto'
            },
            local: {
              conteudo: `${emprestimo.pais}, ${emprestimo.estado}, ${emprestimo.cidade}`,
              tipo: 'texto'
            },
            instituicao: {
              conteudo: (
                <>
                  <Typography>{emprestimo.instituicao}</Typography>
                  <Typography>{emprestimo.cnpj}</Typography>
                </>
              ),
              tipo: 'texto'
            },
            item: {
              conteudo: emprestimo.item.nome,
              avatar: emprestimo.item.destaque !== undefined ? `${process.env.REACT_APP_BACKEND_IMG}${emprestimo.item.destaque.caminho}` : '',
              tipo: 'avatar'
            },
            situacao: {
              conteudo: emprestimo.item.situacao._id,
              id: emprestimo.item._id,
              tipo: 'select',
              dica: 'Mudar Status'
            }
          }))];
          return data;
        });
      } catch (err) {
        console.log(err);
      }
    };
    fetchEmprestimos();
  }, [sendRequest, auth, change]);
  const handleChangeSituacao = async (event, id) => {
    console.log(event.target.value);
    console.log(id);
    try {
      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/acervos/situacao/${id}`,
        'POST',
        JSON.stringify({
          situacao: event.target.value
        }),
        {
          'Content-Type': 'application/json',
          'x-access-token': auth.token
        }
      );
      console.log(responseData);
      if (responseData.sucesso) {
        console.log('Sucesso!');
        setChange(new Date());
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    const fetchSituacoes = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/situacoes/`,
          'GET',
          null,
          {
            'Content-Type': 'application/json',
            'x-access-token': auth.token
          }
        );
        console.log(responseData);
        setSituacoes(responseData.data.map((situacao) => ({ label: situacao.nome, id: situacao._id })));
      } catch (err) {
        console.log(err);
      }
    };
    fetchSituacoes();
  }, [sendRequest, auth]);
  if (navegar) {
    return <Navigate to={`/app/${navegar}`} />;
  }
  return (
    <Page
      className={classes.root}
      title="Solicitações de Empréstimo"
    >
      <Container maxWidth={false}>
        <Box mt={3}>
          <Box
            display="flex"
            justifyContent="flex-start"
            pb={4}
          >
            Solicitações de Empréstimos
          </Box>
          {isLoading && <LoadingSpinner asOverlay />}
          <Tabelas
            data={query !== null ? query : emprestimos}
            estrutura={[
              { id: 'criacao', tipo: 'data', nome: 'Data e Hora' },
              { id: 'nome', tipo: 'texto', nome: 'Nome Completo e Nascimento' },
              { id: 'documento', tipo: 'texto', nome: 'CPF/RG' },
              { id: 'local', tipo: 'texto', nome: 'País, Estado e Cidade' },
              { id: 'instituicao', tipo: 'texto', nome: 'Instituição e CNPJ' },
              { id: 'item', tipo: 'avatar', nome: 'Item' },
              {
                id: 'situacao',
                tipo: 'select',
                nome: 'Alterar Situação',
              },
            ]}
            edit={handleEdit}
            remove={abrirDeletar}
            busca={handleBusca}
            select={{
              options: situacoes,
              label: '',
              onChange: handleChangeSituacao
            }}
            placeholder="Pesquisar item do acervo"
          />
          <ErrorMessage error={error} onClear={clearError} />
        </Box>
      </Container>
      <Modal
        open={remover}
        close={fecharDeletar}
        title="Deseja realmente remover este item do acervo?"
      >
        <Button
          color="primary"
          variant="contained"
          style={{ marginRight: '15px' }}
          onClick={handleDelete}
        >
          Remover Item
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={fecharDeletar}
        >
          Cancelar
        </Button>
      </Modal>
    </Page>
  );
};

export default Emprestimos;
